//TODO: REMOVE THIS FILE WHEN ADD AUCTIONS
//TO REWARDS TABS ON PARTNER PAGE

import { queryClient } from '@capsicum/common';

import {
	useProductsSingleQueries,
	UseProductsSingleQueryKeyBuilder
} from '../data-access/queries/useProductsSingleQueries';

type UseProductsProps = {
	partnerIds: Array<string>;
};

export const usePartnerPageProducts = ({ partnerIds }: UseProductsProps) => {
	const { data: variants, isFetched, isFetching, isLoading } = useProductsSingleQueries(partnerIds);

	return {
		isFetched,
		isFetching,
		isLoading,
		remove: () => queryClient.removeQueries({ queryKey: UseProductsSingleQueryKeyBuilder(partnerIds) }),
		variants
	};
};
